module.exports = __webpack_public_path__ + "static/zoe-web-arm@3x-8848c53e31932db1a80989d45a384d3c.jpg";